module.exports = __webpack_public_path__ + "static/img/id-card-hold.278524be.png";